import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Spin } from 'antd';
import { useAppStore } from '../../stores';
import {
    AppHeader,
    NodesNavigation,
    NodesRenderer,
    ContractStatusModal,
    ContractProcessingResultsRenderer,
    RenewalSuggestionsModal,
    BaseCompanySelectModal,
    CompareContractModal
} from '../../components';
import { CustomDivider, DocumentPreview, ErrorsRenderer } from '../../../custom_shared/components';
import { SessionActionProvider } from '../../context/SessionActionProvider';
import './ContractIngestionAppScreen.less';
import '../../../custom_shared/styles/common.less';

const ContractIngestionAppScreen: React.FC = () => {
    const appStore = useAppStore();

    const { sessionStore, documentPreviewStore, nodesStore, documentVisualStore, contractSubmissionStore } = appStore;

    React.useEffect(() => {
        sessionStore.initialize();
    }, [sessionStore]);

    React.useEffect(() => {
        return () => appStore.dispose();
    }, [appStore]);

    const showSpinner = sessionStore.isInitializing || (sessionStore.inProgress && !nodesStore.nodes.length);

    return (
        <SessionActionProvider>
            <div className="contract-ingestion-app-screen">
                <div className="top-container">
                    <AppHeader />
                    <ContractStatusModal />
                    <CompareContractModal />
                    <ContractProcessingResultsRenderer />
                    <RenewalSuggestionsModal />
                    <BaseCompanySelectModal />

                    {!contractSubmissionStore.contractSending && sessionStore.errorsWithDetails.length > 0 && (
                        <ErrorsRenderer errors={sessionStore.errorsWithDetails} />
                    )}

                    <NodesNavigation />
                </div>

                <CustomDivider type="horizontal" />

                <div className={`bottom-container preview-position-${documentPreviewStore.previewPosition}`}>
                    <div className={`bottom-left-container ${documentPreviewStore.fullScreenMode ? 'expanded' : ''}`}>
                        {showSpinner ? (
                            <div className="loading-overlay">
                                <Spin size="large" />
                            </div>
                        ) : (
                            <NodesRenderer />
                        )}
                    </div>

                    {!documentPreviewStore.fullScreenMode && <CustomDivider type="vertical" />}

                    <div className={`bottom-right-container ${documentPreviewStore.fullScreenMode ? 'hidden' : ''}`}>
                        <DocumentPreview
                            appStore={appStore}
                            sessionStore={sessionStore}
                            documentVisualStore={documentVisualStore}
                            documentPreviewStore={documentPreviewStore}
                            showPageNumbers
                        />
                    </div>
                </div>
            </div>
        </SessionActionProvider>
    );
};

export default observer(ContractIngestionAppScreen);
